<template>
  <v-container grid-list-md>
    <h3>選択質問</h3>
    <v-layout row　align-center>
      <v-flex md3>
        <v-btn color="cyan" class="white--text" :disabled="file==null" @click="importFile">
          <v-icon color="white">backup</v-icon>インポート
        </v-btn>
      </v-flex>
      <v-flex md3>
        <input type="file" @change="selectedFile" />
      </v-flex>
      <v-flex md3>
        <v-btn color="cyan" class="white--text" @click="saveQuestions">保存</v-btn>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs12 sm6>
        <v-card>
          <v-card-title>選択肢</v-card-title>
          <v-card-text>
            <v-layout row wrap v-for="(opt, i) in items.selectOptions" :key="i">
              <v-flex xs9 sm9>
                <v-text-field :value="opt.label" label="Solo" solo readonly></v-text-field>
              </v-flex>
              <v-flex xs2 sm2>
                <v-text-field :value="opt.value" label="Solo" solo readonly></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6>
        <v-card>
          <v-card-title>カテゴリー</v-card-title>
          <v-card-text>
            <v-layout row wrap v-for="(c, i) in items.categoryList" :key="i">
              <v-flex xs9 sm9>
                <v-text-field :value="c" label="Solo" solo readonly></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-card>
      <v-card-title>質問</v-card-title>
      <v-card-text>
        <v-layout v-for="(q, i) in items.questions" :key="i">
          <v-flex xs3 sm1>
            <p>No. {{i+1}}</p>
          </v-flex>
          <v-flex xs6 sm2>
            <v-text-field :value="q.category" label="Solo" solo readonly></v-text-field>
          </v-flex>
          <v-flex xs12 sm9>
            <v-text-field :value="q.question" label="Solo" solo readonly></v-text-field>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import db from "@/components/firebaseInit";
import { mapMutations } from "vuex";
import XLSX from "xlsx";
const headerOfCategoryTable = {
  A1: { t: "s", v: "No", w: "No" },
  B1: { t: "s", v: "category", w: "category" }
};
const headerOfQuestionTable = {
  A1: { t: "s", v: "id", w: "id" },
  B1: { t: "s", v: "category", w: "category" },
  C1: { t: "s", v: "subject_email", w: "question" }
};
export default {
  components: {},
  props: {
    items: {}
  },
  data() {
    return {
      file: null,
      categorys: [],
      questions: [],
      dbRef: db
        .collection("companies")
        .doc(this.$route.params.company_id)
        .collection("surveys")
        .doc(this.$route.params.survey_id),
      newCategorys: [],
      newQuestions: []
    };
  },
  mounted() {},
  methods: {
    importFile() {
      this.changeLoadingState(true);
      const reader = new FileReader();
      reader.readAsArrayBuffer(this.file);
      reader.onload = e => {
        const data = new Uint8Array(reader.result);
        const workbook = XLSX.read(data, { type: "array" });
        this.importCategoryTable(workbook.Sheets["カテゴリー"]);
        this.importQuestionTable(workbook.Sheets["選択質問"]);
        console.log(this.items);
        this.changeLoadingState(false);
      };
    },
    selectedFile(e) {
      e.preventDefault();
      this.file = e.target.files[0];
    },
    importCategoryTable(worksheet) {
      for (let key of Object.keys(headerOfCategoryTable)) {
        worksheet[key] = headerOfCategoryTable[key];
      }
      const items = XLSX.utils.sheet_to_json(worksheet);
      this.getCategorys(
        items.filter(item => {
          return "category" in item && item.category.trim();
        })
      );
    },
    getCategorys(items) {
      const categorys = []
      items.forEach(item => {
        categorys.push(item.category);
      });
      this.items.categoryList = categorys
    },
    importQuestionTable(worksheet) {
      for (let key of Object.keys(headerOfQuestionTable)) {
        worksheet[key] = headerOfQuestionTable[key];
      }
      const items = XLSX.utils.sheet_to_json(worksheet);
      this.getQuestions(
        items.filter(item => {
          return (
            "category" in item &&
            item.category.trim() &&
            "question" in item &&
            item.question.trim()
          );
        })
      );
    },
    getQuestions(items) {
      const questions = []
      items.forEach(item => {
        questions.push(item);
      });
      this.items.questions = questions
    },
    saveQuestions() {
      this.changeLoadingState(true);
      this.$emit("updateQuestions");
      ;
      this.changeLoadingState(false);
    },
    ...mapMutations("app", ["changeLoadingState"])
  }
};
</script>